module.exports = __webpack_public_path__ + "img/clock-twelve.2ea68969.svg";